import {
  Component,
  inject,
  input,
  output
} from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { IconComponent } from '../icon/icon.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { OverlayService } from './overlay.service';
import type { InputSignal, OutputEmitterRef } from '@angular/core';

@Component({
  selector: 'td-wb-overlay',
  templateUrl: 'overlay.component.html',
  styleUrls: ['overlay.component.scss'],
  exportAs: 'tdWbOverlay',
  imports: [IconButtonComponent, IconComponent, TranslatePipe],
  host: {
    '[attr.role]': 'role()',
    '[attr.aria-modal]': 'ariaModal()',
    '(keydown.escape)': 'onKeyDown($event)',
    '[class.td-wb-overlay--gradient-highlight]': 'gradientHighlight()'
  }
})
export class OverlayComponent {
  readonly onClose: OutputEmitterRef<void> = output<void>();
  readonly role: InputSignal<string> = input<string>('dialog');
  readonly ariaModal: InputSignal<string> = input<string>('true');
  readonly gradientHighlight: InputSignal<boolean> = input<boolean>(false);

  private readonly overlayService = inject(OverlayService);

  onKeyDown(event: Event): void {
    event.stopPropagation();
    this.close();
  }

  close(): void {
    this.onClose.emit();
    this.overlayService.close();
  }
}
